<div class="accordion-item">
    <h3 class="accordion-header" id="headingOne">
        <button class="accordion-button" (click)="showRegulator = !showRegulator"
            [ngClass]="{'collapsed':!showRegulator}" type="button" data-bs-toggle="collapse"
            data-bs-target="#INSRegulator" aria-expanded="true" aria-controls="INSRegulator">
            <span>Regulator</span>
            <div class="arrow"></div>
        </button>
    </h3>
    <div *ngIf="regulatorForm" id="INSRegulator" class="accordion-collapse collapse" [ngClass]="{'show':showRegulator}"
        aria-labelledby="INSRegulator" [formGroup]="regulatorForm">
        <div class="accordion-body">

            <div class="row">
                <div class="col-3 mb-3">
                    <label for="INSCountry3" class="form-label">Country<span class="mandatory">*</span></label>
                    <div
                        [ngClass]="{'is-invalid' : submitted && regulatorForm?.controls?.['country']?.errors?.['required']}">
                        <app-single-select uid="countryId" [searchShow]=true [dataArr]="countryList"
                            (selectedEvent)="selectedValue($event,'country');" label="countryName"
                            [selectedData]="regulatorForm.value.country" [placeholder]="'Select'">
                        </app-single-select>
                    </div>
                    <span *ngIf="submitted && regulatorForm?.controls?.['country']?.errors?.['required']"
                        class="invalid-feedback d-block" tabindex="0">This field is required</span>
                </div>


                <div class="col-3 mb-3">
                    <label for="INSRegulator1" class="form-label">Regulator<span class="mandatory">*</span></label>
                    <div
                        [ngClass]="{'is-invalid' : submitted && regulatorForm?.controls?.['regulator']?.errors?.['required']}">
                        <app-single-select uid="regulatoryId" [dataArr]="regulatorList"
                            (selectedEvent)="selectedValue($event,'regulator');" label="regulatoryAuthority"
                            [selectedData]="regulatorForm.value.regulator" [placeholder]="'Select'">
                        </app-single-select>
                    </div>
                    <span *ngIf="submitted && regulatorForm?.controls?.['regulator']?.errors?.['required']"
                        class="invalid-feedback d-block" tabindex="0">This field is required</span>
                </div>


                <div class="col-3 mb-3">
                    <label for="INSReceiverID" class="form-label">Receiver ID<span class="mandatory">*</span></label>
                    
                    <input autocomplete="disabled" type="text" id="insContactEmail{{uniQueId}}" formControlName="receiverId"  class="form-control"
                    [ngClass]="{'is-invalid' : submitted && regulatorForm?.controls?.['receiverId']?.errors?.['required']}" appPreventFirstSpace>
                    <span *ngIf="submitted && regulatorForm?.controls?.['receiverId']?.errors?.['required']"
                        class="invalid-feedback d-block" tabindex="0">This field is required</span>
                </div>


                <div class="col-3 mb-3">
                    <label for="INSPayerID" class="form-label">Payer ID<span class="mandatory">*</span></label>
                    
                    <input autocomplete="disabled" type="text" id="insContactEmail" formControlName="payerId"  class="form-control"
                    [ngClass]="{'is-invalid' : submitted && regulatorForm?.controls?.['payerId']?.errors?.['required']}" appPreventFirstSpace>
                    <span *ngIf="submitted && regulatorForm?.controls?.['payerId']?.errors?.['required']"
                        class="invalid-feedback d-block" tabindex="0">This field is required</span>
                </div>


            </div>
        </div>
    </div>



</div>